// JavaScript Document

export const init = () =>{
	pnlRemove();
	setPrdCtgList();
	organizeProducts();
	clickBrandImg();
}
const removePnl=["business","machine"];

const pnlRemove =()=>{
	removePnl.forEach((p) =>{
		let rmvPnl=document.querySelectorAll(".bubble_"+p);
		rmvPnl.forEach((c) =>{
			c.closest(".brdLi").remove();
		});
	});
}


const setPrdCtgList = () =>{
	let viwdata;
	let ctgCod=document.querySelector(".ctgCod").textContent;
	let prdTmp = document.getElementById('productsTemp');
	
	fetch('/ajax/products/'+ctgCod+'.json')
		.then(response => response.json())
		.then(json => {
		viwdata=json.rt_bn_brand_product_list;
		
		setDom();
	}).catch(error => {
		console.log(error);
	});
	
	
	const setDom =() =>{
		viwdata.forEach((obj) =>{
			let brand=obj.p_brand_code;
			let prdWrap=document.querySelector('[data-brd="'+brand+'"]');
			
			if(prdWrap!=null){
				let udr6=prdWrap.querySelector(".under6");
				let ovr6=prdWrap.querySelector(".over6");
				let clone = prdTmp.content.cloneNode(true);
				clone.querySelector(".prdName").textContent=obj.p_name;
				clone.querySelector(".prdImgFile").setAttribute("data-src","/products/product_file_lotte/product_file/"+obj.p_img_file+"?_size=6");
				clone.querySelector("a").setAttribute("href","/products/catalogue/"+obj.p_category_code+"/"+obj.p_brand_number+"/detail"+obj.p_number+".html");
				
				let newFlg=clone.querySelector("p.label");
				if(obj.p_new_flg!=""){
					newFlg.textContent=obj.p_new_flg;
					newFlg.classList.add(obj.p_new_flg);
				}else{
					newFlg.remove();
				}
				
				clone.querySelector(".prdImgFile").onload=function(e){
					e.target.closest(".image").querySelector(".loaderWrap").remove();
				}
				if(udr6.childElementCount<6){
					udr6.appendChild(clone);
				}else{
					ovr6.appendChild(clone);
				}
			}
			
		});
		lazyload(document.querySelectorAll(".productList img"));
		
		
		let details=document.querySelectorAll(".productList");
		details.forEach((wrap) => {
			let mainUl=wrap.querySelector("ul.under6");
			let subUl=wrap.querySelector("ul.over6");
			let cnt=subUl.childElementCount;
			let exBt=wrap.querySelector("button.overPrdBt");
			if(cnt==0){
				subUl.remove();
				exBt.remove();
			}else{
				exBt.addEventListener("click",function(b){
					if(this.getAttribute("aria-expanded")=="false"){
						subUl.setAttribute("aria-hidden","false");
						this.setAttribute("aria-expanded","true");
						
						setTimeout(() => {
							subUl.querySelector("a").focus();
						}, "200");
						
					}else{
						subUl.setAttribute("aria-hidden","true");
						this.setAttribute("aria-expanded","false");
					}
				});
			}
		});
		
	}
}

const organizeProducts = () =>{
	
	
	const allImg=document.querySelectorAll(".prdImg");
	allImg.forEach((o)=>{
		o.onload=function(e){
			e.target.closest(".image").querySelector(".loaderWrap").remove();
		}
	});
	lazyload(document.querySelectorAll(".brdImage img"));
}

const clickBrandImg = () =>{
	let aTag=document.querySelectorAll("a.brandsBt");
	let openFlg=false;
	
	aTag.forEach((elem) =>{
		let bblID=elem.closest('.brdLi');
		//bblID.querySelector(".productList").getAttribute("id");
		//elem.setAttribute("href","#"+bblID);
		elem.addEventListener("click",function(event){
			event.preventDefault();
			let nowAct=document.querySelectorAll(".brdLi.active");
			let flg=this.closest("li").classList.contains("active");
			
			nowAct.forEach((act) =>{
				bblCont(act.closest("li"),false);
				if(!flg){
					openFlg=false;
				}else{
					openFlg=true;
				}
				
			});
			
			if(!flg){
				bblCont(this.closest("li"),true);
				openFlg=true;
			}else{
				bblCont(this.closest("li"),false);
				openFlg=false;
			}
			
		});
		console.log(bblID.querySelector("a.bubbleClose"));
		bblID.querySelector("a.bubbleClose").addEventListener("click",function(bt){
			bt.preventDefault();
			bblCont(bblID,false);
			openFlg=false;
		});
		
	});
	
	document.addEventListener('click', (e) => {
		if(!e.target.closest('.brdLi')) {
			if(openFlg){
				aTag.forEach((elem) =>{
					let trg=elem.closest("li");
					if(trg.classList.contains("active")){
						bblCont(trg,false);
					}else if(trg.classList.contains("disable")){
						trg.classList.remove("disable");
					}
				});
				openFlg=false;
			}
		}
	});
	
	const bblCont = (trg,mod) =>{
		if(mod){
			//吹出しopenルーチン
			trg.classList.add("active");
			trg.querySelector(".productList").ariaHidden=false;
			trg.querySelector(".brandsBt").ariaExpanded=true;
		}else{
			//吹出しcloseルーチン
			trg.classList.remove("active");
			trg.querySelector(".productList").ariaHidden=true;
			trg.querySelector(".brandsBt").ariaExpanded=false;
			let ov6=trg.querySelector(".over6");
			if(ov6!= null){
				ov6.ariaHidden=true;
				trg.querySelector("button.overPrdBt").ariaExpanded=false;
			}
		}
		
		const lits=document.querySelectorAll(".brdLi")
		lits.forEach((t) =>{
			if(!openFlg){
				if(!t.classList.contains("active")){
					t.classList.add("disable");
				}else{
					t.classList.remove("disable");
				}
			}else{
				t.classList.remove("disable");
			}
		});
	}
}

